// extracted by mini-css-extract-plugin
export default {"countersContainer":"opportunities-module___countersContainer___c14194fb"};